import { usePublicSiteSettings } from '@contexts/PublicSiteSettingsContext';

/**
 * Registration open/closed for public pages (landing, login).
 * Uses cached site settings immediately when available; shows pending state only on first load.
 */
export function useRegistrationVisibility() {
  const {
    loading,
    registrationPending,
    registrationsOpen,
    showRegistrationClosedNotice,
    registrationClosedNoticeText,
  } = usePublicSiteSettings();

  const registrationResolved = !loading;

  return {
    loading,
    registrationPending,
    registrationResolved,
    registrationsOpen,
    showRegistrationClosed: registrationResolved && showRegistrationClosedNotice,
    showRegister: registrationsOpen,
    registrationClosedNoticeText,
  };
}
